export function YearsToRanges(years) {
  if (years) {
    if (years > 10) return 'yli 10 vuotta';
    if (years >= 6) return '6-10 vuotta';
    if (years >= 3) return '3-5 vuotta';
    if (years >= 1) return '1-2 vuotta';
  }
  return '-';
}
